import { useState } from 'react';

import { Stack } from '@eluve/components';

import {
  DefaultDetailPanel,
  DefaultsOverviewPanel,
  EmptyState,
  PanelHeader,
} from './components';
import { useGlobalPromptDefaultsData } from './hooks';

export const GlobalPromptDefaultsTab: React.FC = () => {
  const {
    globalDefaults,
    llmOutputTypes,
    promptTemplates,
    outputTemplates,
    refetchDefaults,
  } = useGlobalPromptDefaultsData();

  const [selectedOutputType, setSelectedOutputType] = useState<string | null>(
    null,
  );
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <Stack
      align="stretch"
      className="mt-4 max-h-[70vh] min-h-[500px] rounded-lg border border-border-tertiary"
      direction="horizontal"
    >
      {/* Left Column - Defaults Overview (30%) */}
      <Stack
        className="w-[30%] shrink-0 overflow-y-auto border-r border-border-tertiary"
        gap={2}
      >
        <DefaultsOverviewPanel
          defaults={globalDefaults}
          entityType="global"
          onAddClick={() => setDialogOpen(true)}
          selectedOutputType={selectedOutputType}
          onSelectOutputType={setSelectedOutputType}
        />
      </Stack>

      {/* Right Column - Detail View (70%) */}
      <Stack className="w-[70%] shrink-0 overflow-y-auto" gap={2}>
        {selectedOutputType || dialogOpen ? (
          <DefaultDetailPanel
            defaults={globalDefaults}
            entityType="global"
            llmOutputTypes={llmOutputTypes}
            promptTemplates={promptTemplates}
            outputTemplates={outputTemplates}
            onRefreshTemplates={() => refetchDefaults()}
            selectedOutputType={selectedOutputType}
            dialogOpen={dialogOpen}
            onOpenDialog={() => setDialogOpen(true)}
            onDialogOpenChange={setDialogOpen}
          />
        ) : (
          <Stack align="stretch" fullHeight>
            <PanelHeader title="Details" cornerRadius="tr" />
            <EmptyState
              message="Select an output type to view details"
              centered
            />
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
